import { IFpayParams } from "@/api/apiRsp/IFWalletRsp";
import { SelectUIProps } from "@/componentsUI/Select";
import React from "react";
import classNames from "classnames";
import {
  getPaymentIcon,
  sortPaymentParams,
} from "@/pages/wallet/shared/PaymentMethodUtils";
import "./index.less";

export interface DepositWayProps extends SelectUIProps {
  payParams: IFpayParams[];
  onChange?: any;
  value?: any;
}

const DepositWay = (props: DepositWayProps) => {
  const { payParams, value, onChange } = props;
  const orderedPayParams = sortPaymentParams(payParams || []);

  function handleChange(payName: string) {
    // 找到对应的支付方式数据 (MTN/Vodafone/AirtelTigo等)
    const index = orderedPayParams?.findIndex((element) => {
      return element.payName === payName;
    });
    const item = orderedPayParams?.[index] || {};

    onChange &&
      onChange({
        type: payName,
        data: item,
      });
  }

  return (
    <div className="deposit-way">
      <div className="payment-channels">
        {orderedPayParams?.map((option: IFpayParams, index) => {
          const icon = getPaymentIcon(option.payName);

          return (
            <div
              key={index}
              className={classNames("channel-item", {
                active: value?.type === option.payName,
              })}
              onClick={() => handleChange(option.payName)}
            >
              {icon && (
                <img src={icon} alt={option.payName} className="channel-icon" />
              )}
              <span className="channel-text">{option.payName}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DepositWay;
